import styled from "styled-components";

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 20px;
`;

export default HeaderContainer;
